export default __webpack_public_path__ + "static/import-design-gif-9a9fa6ea76258783aa31d776bd5f2557.gif";